import { fetcher } from "../api/fetcher";
import { activeRoomState } from "../states/active_room";
import { authState } from "../states/auth";
import { setCallId } from "../states/callState";
import { goFinish } from "../states/finishState";
import { addInitialHands, selfHandUpState } from "../states/handUpState";
import { apiConnected } from "../states/media/api";
import { desiredMediaState } from "../states/media/state";
import {
  loadingRecordState,
  recordState,
  showRoomRecordNotification,
} from "../states/recordState";
import { roomState } from "../states/room";
import { clearSharedByApi, newSharedByApi } from "../states/screenShareState";
import { UserInRoom, addOrUpdateUserInList } from "../states/usersState";
import {
  RequestUser,
  addUsersInWaitState,
  showWaitRoomNotification,
} from "../states/waitRoomState";
import { ws_instance } from "../websocket/ws-instance";

const state = {
  firstConnectSyncInfoReceived: false,
  resolve: undefined as ((val:unknown) => void) | undefined,
};
export async function firstConnectSyncInfo() {
  if (state.firstConnectSyncInfoReceived) return;
  else {
    return new Promise((resolve) => {
      state.resolve = resolve;
    });
  }
}

export function subscribe_sync_info() {
  ws_instance.addEventListener(
    "sync_info",
    (data: {
      users: UserInRoom[];
      shared: string;
      allMute?: string;
      record: "active" | "off" | "starting";
      hands?: string[];
      requests?: RequestUser[];
      callId: string;
    }) => {
      setCallId(data.callId)
      if (data.requests) {
        addUsersInWaitState(data.requests);
        if (data.requests.length > 0) {
          showWaitRoomNotification();
        }
      }
      if (data.hands) {
        if (data.hands.includes(authState.id)) {
          selfHandUpState.value = true;
        }
        addInitialHands(data.hands);
      }
      data.users
        .filter((u) => u.id !== authState.id)
        .forEach((u) => {
          addOrUpdateUserInList(u)
        });
      if (data.shared) {
        newSharedByApi(data.shared);
      } else {
        clearSharedByApi()
      }
      if (data.record === "active") {
        recordState.recording = true;
        showRoomRecordNotification();
      } else if (data.record === "starting") {
        recordState.recording = false;
        loadingRecordState.value = true;
      }
      if (data.allMute && data.allMute !== authState.id) {
        activeRoomState.allMute = data.allMute
      }
      state.firstConnectSyncInfoReceived = true;
      if (state.resolve) {
        state.resolve(true);
        state.resolve = undefined;
      }
    },
  );
}

export async function sync_info() {
  const deviceStates = {
    micro: desiredMediaState.microEnabled,
    camera: desiredMediaState.cameraEnabled,
  };
  const user = {
    id: authState.id,
    displayedName: authState.displayedName,
    avatar: authState.avatar,
    micro: deviceStates.micro,
    camera: deviceStates.camera,
  };
  fetcher
    .post({
      path: "/active-room/sync_info",
      payload: {
        user: user,
        room_id: roomState.id,
      },
    })
    .then(() => {
      apiConnected(deviceStates);
    })
    .catch((err) => {
      if (err?.status === 400 && err?.data?.message === "room not active") {
        //
      } else if (err?.status === 405) {
        goFinish("kick");
        throw "not allowed";
      }
    });
}
